import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { convertStringToArray, extractDate } from "../../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";

const EventArchiveDetailPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { id } = useParams();
  const {
    data: eventsData = [],
    error,
    isLoading: eventsIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "archive_event",
    lang: languageType,
  });

  const selectedEvent = eventsData.find((event) => event.nid === id);

  console.log(selectedEvent);

  // const coverPhoto = selectedEvent?.field_events_image?.split(", ")[0];
  // const coverPhoto = selectedEvent?.field_upload_image?.split(", ")[0];

  const coverPhoto = convertStringToArray(selectedEvent?.field_upload_image);

  console.log(coverPhoto[0]);

  const modifiedObj = {
    ...selectedEvent,
    field_download: convertStringToArray(selectedEvent?.field_download),
  };

  const file_ext = modifiedObj.field_video?.slice(-3);

  // const lastUpdatedOn = useMemo(() => {
  //   return extractDateFromStr(getLatestUpdatedObject(selectedEvent)?.changed);
  // }, [selectedEvent]);

  const lastUpdatedOn = useMemo(() => {
    return extractDate(selectedEvent);
  }, [selectedEvent]);

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (eventsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Archived Events", "संग्रहीत गतिविधियाँ")}
        titleLink="/archived-events"
        titleTwo={selectedEvent?.title}
        levelTwo={true}
        levelThree={false}
        isActive={selectedEvent?.title}
      />
      <div className="inner-container">
        <div className="container">
          <section className="news-detail">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              {selectedEvent ? (
                <>
                  {" "}
                  <div className="row mb-5">
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="card-sec">
                        <div className="img-sec">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}/${coverPhoto[0].file_path}`}
                            alt={selectedEvent.title}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                      <div className="title-sec">
                        <h4>{selectedEvent.title}</h4>
                      </div>
                      <div className="about_inntxt">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: selectedEvent.body,
                          }}
                        ></div>
                        {/* <p>{selectedEvent.field_events_description}</p> */}
                        {modifiedObj.field_video && file_ext === "mp4" ? (
                          <>
                            <div className="title4">
                              <h4>Video</h4>
                            </div>
                            <video controls>
                              <source
                                src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-07/${selectedEvent.field_video}`}
                                type="audio/mpeg"
                              />
                            </video>
                          </>
                        ) : modifiedObj.field_video && file_ext === "mp3" ? (
                          <>
                            <div className="title4">
                              <h4>Audio</h4>
                            </div>
                            <audio controls>
                              <source
                                src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-07/${selectedEvent.field_video}`}
                                type="audio/mpeg"
                              />
                            </audio>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {modifiedObj.field_download.length > 0 && (
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-4">
                        <div className="table-responsive">
                          <table className="table table-striped custom-table">
                            <thead className="thead-dark">
                              <tr>
                                <th>S. No.</th>
                                <th>Description</th>
                                <th>Download</th>
                              </tr>
                            </thead>
                            <tbody>
                              {modifiedObj?.field_download.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.title}</td>
                                    <td>
                                      <a
                                        href={`${process.env.REACT_APP_IMAGE_URL}/${item?.file_path}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div className="pdf-icon">
                                          <img
                                            src="./images/pdf-icon.png"
                                            alt="pdf-icon"
                                            className="mr-2"
                                          />
                                        </div>
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <p>event with id {id} not found</p>
                </>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default EventArchiveDetailPage;
